import React from 'react';

const NAVBAR_TABS = [
  { id: 'generalInformation', name: 'General Information', steps: ['boat_type', 'engine_type', 'boat_specifications'] },
  { id: 'addComponents', name: 'Add Components', steps: ['add_components'] },
  {
    id: 'boatCalculations',
    name: 'Boat Calculations',
    steps: ['cubic_capacity', 'weight_capacity', 'power_capacity', 'floatation_capacity'],
  },
  {
    id: 'loadDocks',
    name: 'Additional Documents',
    steps: ['load_documents'],
  },
  { id: 'finalReview', name: 'Final Review', steps: ['final_review'] },
];

const STATUSES = {
  valid: 'valid',
  empty: 'empty',
  invalid: 'invalid',
  current: 'current',
};

class StepNavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTabIndex: '',
      tabsList: [],
    };
  }

  componentDidMount() {
    this.getTabsList();
  }

  getTabsList = () => {
    const { step, stepsList } = this.props;
    let currentTabIndex = '';
    let tabsList = [];
    NAVBAR_TABS.forEach(tab => {
      let steps = [];
      tab.steps.forEach(stepId => {
        if (stepsList.find(st => st.id === stepId)) steps.push(stepId);
        if (stepId === step) {
          currentTabIndex = tabsList.length;
        }
      });
      if (steps.length) tabsList.push({ id: tab.id, name: tab.name, steps: steps });
    });
    this.setState({ tabsList: tabsList, currentTabIndex: currentTabIndex });
  };

  goToStep = stepId => () => {
    const { step, stepsList, handleMoveToArbitraryStep, handleMoveToNextStep } = this.props;
    const currentStepIndex = stepsList.findIndex(st => st.id === step);
    const nextStepIndex = stepsList.findIndex(st => st.id === stepId);
    //TODO uncomment this string to allow quick steps navigation for debugging
    //if (nextStepIndex !== currentStepIndex && process.env.NODE_ENV === 'development') return handleMoveToArbitraryStep(stepId);
    if (nextStepIndex < currentStepIndex) handleMoveToArbitraryStep(stepId);
    else if (nextStepIndex - 1 === currentStepIndex) handleMoveToNextStep();
    else if (this.checkIfPreviousStepsAreValid(nextStepIndex)) handleMoveToArbitraryStep(stepId);
  };

  checkIfPreviousStepsAreValid = nextStepIndex => {
    const { stepsList, stepsValidation } = this.props;
    let previousStepsAreValid = true;
    stepsList.forEach((step, index) => {
      if (index < nextStepIndex && !stepsValidation[step.id]) previousStepsAreValid = false;
    });
    return previousStepsAreValid;
  };

  goToTab = tabIndex => () => {
    const { stepsValidation } = this.props;
    const { tabsList } = this.state;

    let lastValidStepId = tabsList[tabIndex].steps[0];
    tabsList[tabIndex].steps.forEach(stepId => {
      if (stepsValidation[stepId]) lastValidStepId = stepId;
    });
    this.goToStep(lastValidStepId)();
  };

  getTabStatus = tabIndex => {
    const { currentTabIndex, tabsList } = this.state;
    const { stepsValidation } = this.props;
    let status = null;

    if (!tabsList[tabIndex]) return STATUSES.empty;

    if (tabIndex === currentTabIndex) {
      status = STATUSES.current;
    } else {
      tabsList[tabIndex].steps.forEach(stepId => {
        if (stepsValidation[stepId] !== undefined) {
          status = stepsValidation[stepId] ? status || STATUSES.valid : STATUSES.invalid;
        } else {
          status = STATUSES.empty;
        }
      });
    }
    return status;
  };

  getStepStatus = stepId => {
    const { stepsValidation, step } = this.props;

    if (stepId === step) return STATUSES.current;
    else if (stepsValidation[stepId] === undefined) return STATUSES.empty;
    else if (stepsValidation[stepId]) return STATUSES.valid;
    else if (!stepsValidation[stepId]) return STATUSES.invalid;
  };

  getSteps = () => {
    const { tabsList, currentTabIndex } = this.state;
    const { stepsList } = this.props;

    if (!tabsList[currentTabIndex] || tabsList[currentTabIndex].steps.length === 1) return null;

    const steps = tabsList[currentTabIndex].steps;
    return (
      <div className={'steps-wrapper'}>
        {steps.map(stepId => {
          const step = stepsList.find(st => st.id === stepId);
          return (
            <React.Fragment key={stepId}>
              <div className={`step ${this.getStepStatus(stepId)}`} onClick={this.goToStep(stepId)}>
                {step ? step.name : ''}
                <div className='circle'>
                  <div className='check-mark' />
                </div>
              </div>
              <div className={`step-delimiter ${this.getStepStatus(stepId)}`} />
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  render() {
    const { tabsList } = this.state;

    return (
      <section className={'step-navbar-section'}>
        <div className={'tabs-wrapper'}>
          {tabsList.map((tab, index) => {
            return (
              <div key={tab.id} className={`tab ${this.getTabStatus(index)}`} onClick={this.goToTab(index)}>
                <div />
                {tab.name}
              </div>
            );
          })}
        </div>
        {this.getSteps()}
      </section>
    );
  }
}

export default StepNavBar;



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/StepNavBar.jsx